class SftpConfigController extends AbstractSftpController
	@register()

	integrationId: 'sftp'
